module.exports = __webpack_public_path__ + "img/2.9288d133.png";